/**
 * Created by jjing on 6/6/2017.
 */
import React, {Component} from 'react';
import {Form, Input, Button, Select, Row, Col, Radio, Icon, AutoComplete} from 'antd';
import {Alert} from 'react-bootstrap';
import request from 'superagent';
import Constants, {OPERATOR_TYPES, POLICY_TRANSPORTS, SERVICE_ID_LIST, PRODUCT_SHOW_NAME, Permissions, Lock_Status} from '../../commons/Constants';
import {PermissionCtrl, openNotification, NotificationType} from "../../commons/CommonUtils";
import Loading from "../../commons/Loading";

const FormItem = Form.Item;
const Option = Select.Option;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
const _URL_REG_EXP = /^(((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/;
//const _HOST_REG_EXP = /^[a-zA-Z0-9]{1}[a-zA-Z0-9\-\.]{0,61}[a-zA-Z0-9]{1}$/;

const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 6}
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 18}
    },
};

const formItemLayoutOffset = {
    labelCol: {
        sm: {span: 4, offset: 2}
    },
    wrapperCol: {
        sm: {span: 18}
    }
};

const CredentialNote = (props) => <p>If using a private container registry for which username/password credentials are
    required, use only credentials for an Azure Active Directory Service Principal assigned the "Reader" role in order
    to mitigate the risk of accidental disclosure of the credentials via the softupdate service.</p>

const ContainerRegistry = (props) => {
    const {serviceDepends, transport, getFieldDecorator, addService, deleteService, getCurentProductRegExp, data} = props;

    if (transport === "container-registry") {
        const services = serviceDepends.map((service, index) => {
            if (service)
                return <ServiceDependItem key={index} index={index} getFieldDecorator={getFieldDecorator} data={service}
                                          deleteService={deleteService}/>
        });

        return (
            <div className="policy-config-services-div">
                <FormItem {...formItemLayout} label="Release Version" hasFeedback>
                    {getFieldDecorator('meta_Version', {
                        initialValue: data["meta"]["Version"],
                        rules: [{
                            required: true,
                            pattern: getCurentProductRegExp(),
                            message: "Please input valid release version. " + getCurentProductRegExp()
                        }],
                    })(
                        <Input placeholder="Version: X.Y.Z-build number"/>
                    )}
                </FormItem>
                {services}
                <Row>
                    <Col span={8}>
                        <Button type="dashed" className="policy-config-linkbtn" onClick={() => addService()}><Icon
                            type="plus"/>Add Service Dependency</Button>
                    </Col>
                </Row>
            </div>);
    }
    else
        return null;
}


const ServiceDependItem = (props) => {
    const {index, getFieldDecorator, data, deleteService} = props;

    return (
        <Row>
            <Col span={16}>
                <FormItem labelCol={{sm: {span: 12}}} wrapperCol={{sm: {span: 12}}}
                          label={"Service Dependency#" + (index + 1)}>
                    {getFieldDecorator('meta_ServiceDependencies_' + index + '_key', {
                        initialValue: data["key"],
                        rules: [{
                            required: true, message: 'Please input service name!',
                        }],
                    })(
                        <AutoComplete
                            dataSource={SERVICE_ID_LIST}
                            filterOption={(inputValue, option) => option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                            />
                    )}
                </FormItem>
            </Col>

            <Col span={7}>
                <FormItem hasFeedback labelCol={{sm: {span: 0}}} wrapperCol={{sm: {span: 24}}}>
                    {getFieldDecorator('meta_ServiceDependencies_' + index + '_value', {
                        initialValue: data["value"],
                        rules: [{
                            required: true, pattern: /^(\d+)\.(\d+)$/, message: 'Please input valid service version! ',
                        }],
                    })(
                        <Input placeholder="Version: X.Y"/>
                    )}
                </FormItem>
            </Col>
            <Col span={1}>
                <a className="policy-config-linkicon" onClick={() => deleteService(index)}><Icon type="minus-circle-o"/></a>
            </Col>
        </Row>
    );
}


const URLItem = (props) => {
    const {transport, getFieldDecorator, validateFields, data, isAccountExpanded, showAccountSettings, userNameValue} = props;

    const credentialUser = (<FormItem {...formItemLayoutOffset}
        label="User Name" hasFeedback>
        {getFieldDecorator('credentials_username', {
            initialValue: data["credentials"] ? data["credentials"]["username"] : "",
            rules: [{max: 64, message: "User name length can not be over 64."}],
        })(
            <Input onBlur={() => {
                validateFields(['credentials_password'], {force: true})
            }}/>
        )}
    </FormItem>);

    const credentialPasswd = (<FormItem {...formItemLayoutOffset} label="Password" hasFeedback>
        {getFieldDecorator('credentials_password', {
            initialValue: data["credentials"] ? data["credentials"]["password"] : "",
            rules: [{
                required: userNameValue,
                max: 64,
                message: "Please input password, its length can not be over 64."
            }]
        })(
            <Input type="password"/>
        )}
    </FormItem>);

    if (transport === "https") {
        return (
            <div>
                <FormItem {...formItemLayout} label="URL Path" hasFeedback>
                    {getFieldDecorator('urlPath', {
                        initialValue: data["urlPath"],
                        rules: [{
                            required: true, pattern: _URL_REG_EXP, message: 'Please input valid URL!',
                        }],
                    })(
                        <Input addonBefore="https://" style={{width: "100%"}}/>
                    )}
                </FormItem>
                {
                    isAccountExpanded ?
                        (<div>
                            {credentialUser}
                            {credentialPasswd}
                        </div>)
                        :
                        (<Row>
                            <Col span={16} offset={8}>
                                <a className="policy-config-linkbtn" onClick={showAccountSettings}>Account Setting</a>
                            </Col>
                        </Row>)
                }
            </div>);
    } else if (transport === "container-registry") {
        return (
            <div>
                <FormItem {...formItemLayout} label="Image Path" hasFeedback>
                    {getFieldDecorator('urlPath', {
                        initialValue: data["urlPath"],
                        rules: [{
                            required: true, pattern: _URL_REG_EXP, message: 'Please input valid image path!',
                        }],
                    })(
                        <Input/>
                    )}
                </FormItem>
                {
                    isAccountExpanded ?
                        (<div>
                            {credentialUser}
                            {credentialPasswd}
                        </div>)
                        :
                        (<Row>
                            <Col span={16} offset={8}>
                                <a className="policy-config-linkbtn" onClick={showAccountSettings}>Account Setting</a>
                            </Col>
                        </Row>)
                }
            </div>);
    } else
        return null;
}

class PolicyConfigForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status: Constants.STATUS.init
        }
    }

    componentDidMount() {
        let serviceDepends = [];

        if (this.props.data.meta && this.props.data.meta.ServiceDependencies) {
            const ServiceDependencies = this.props.data.meta.ServiceDependencies;
            serviceDepends = Object.keys(ServiceDependencies).map((name) => {
                return {key: name, value: ServiceDependencies[name]};
            });
        }
        if (this.props.data.credentials && this.props.data.credentials.username)
            this.setState({serviceDepends: serviceDepends, isAccountExpanded: true});
        else
            this.setState({serviceDepends: serviceDepends});
    }

    checkVersionFormat = (rule, value, callback) => {
        const form = this.props.form;
        const {products} = this.props;
        let productValue = form.getFieldValue('products');
        let hasError = false;

        if (productValue && value) {
            if (Array.isArray(productValue))
                productValue = productValue[0];

            products.forEach((product) => {
                if (product.product === productValue) {
                    const exp = product.versionRegExp;
                    var isValid = new RegExp(exp).test(value);
                    if (!isValid) {
                        hasError = true;
                        callback("Version format error." + exp);
                    }
                }
            });
        }
        if (!hasError)
            callback();
    }

    convertFormData = (formData) => {
        console.dir(formData);
        formData = Object.assign({}, this.props.data, formData);

        formData["version"]["operator"] = formData["version_operator"];
        formData["version"]["value"] = formData["version_value"];
        if (!Array.isArray(formData["transports"]))
            formData["transports"] = [formData["transports"]];

        //Optional inputs
        formData["credentials"] = {};
        if (formData["credentials_username"]) {
            formData["credentials"]["username"] = formData["credentials_username"];
            if (formData["credentials_password"])
                formData["credentials"]["password"] = formData["credentials_password"];
            // else
            //     formData["credentials"]["password"] = "";
        } else {
            delete formData.credentials;
        }

        if (!Array.isArray(formData.products)) {
            formData.products = [formData.products];
        }

        //build meta
        if (formData["transports"][0] === "https")
            delete formData.meta;
        else {
            formData["meta"]["Products"] = formData.products;
            formData["meta"]["Format"] = "0.0.1";
            formData["meta"]["Version"] = formData["meta_Version"];
            formData["meta"]["ServiceDependencies"] = {};
            const serviceObjList = this.convertService(formData, true);
            Object.keys(serviceObjList).forEach((service) => {
                if (service) {
                    const key = serviceObjList[service]["key"];
                    const value = serviceObjList[service]["value"];
                    if (key) {
                        formData["meta"]["ServiceDependencies"][key] = value;
                    }
                }
            })
        }

        //clean component data
        if (!formData.tid)
            delete formData.tid;

        delete formData.version_operator;
        delete formData.version_value;
        delete formData.meta_Version;
        delete formData.credentials_username;
        delete formData.credentials_password;

        console.dir(formData);
        return formData;
    }

    save = (event) => {
        event.preventDefault();

        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({status: Constants.STATUS.trying});
                let data = Object.assign({}, values);
                data = this.convertFormData(values);

                if (this.props.editMode) {
                    request.put('/api/pec1sumiddleware')
                        .query({urlPath: '/policy'})
                        .send(data)
                        .end((err, res) => {
                            if (err) {
                                this.setState({
                                    status: Constants.STATUS.error,
                                    message: "Fail to modify policy. " + err.message
                                });
                            } else {
                                this.props.close();
                                openNotification("Succeed to save policy.", NotificationType.success);
                                this.setState({status: Constants.STATUS.done, message: "Succeed to save policy."});
                            }
                        })
                } else {
                    request.post('/api/pec1sumiddleware')
                        .query({urlPath: '/policy'})
                        .send(data)
                        .end((err, res) => {
                            if (err) {
                                this.setState({
                                    status: Constants.STATUS.error,
                                    message: "Fail to add policy. " + err.message
                                });
                            } else {
                                this.props.close();
                                openNotification("Succeed to save policy.", NotificationType.success);
                                this.setState({status: Constants.STATUS.done, message: "Succeed to save policy."});
                            }
                        })
                }
            }
        });
    }

    convertService = (values, isDelete) => {
        const serviceList = Object.keys(values).filter((name) => name.indexOf("meta_ServiceDependencies_") >= 0);
        let serviceMap = [];
        serviceList.forEach((ser) => {
            const keys = ser.replace("meta_ServiceDependencies_", "").split("_");
            let value = serviceMap[keys[0]];
            if (value)
                value[keys[1]] = values[ser];
            else {
                value = {};
                value[keys[1]] = values[ser];
            }
            serviceMap[keys[0]] = value;
        })
        if (isDelete) {
            serviceList.forEach((key) => {
                delete values[key];
            })
        }
        return serviceMap;
    }


    addService = () => {
        let services = this.state.serviceDepends;
        const values = this.props.form.getFieldsValue();
        services = this.convertService(values);
        services.push({key: "", value: ""});
        this.setState({serviceDepends: services});
    }

    deleteService = (index) => {
        let services = this.state.serviceDepends;
        const values = this.props.form.getFieldsValue();
        services = this.convertService(values);
        services[index] = "";
        this.setState({serviceDepends: services});
    }

    showAccountSettings = () => {
        this.setState({isAccountExpanded: true});
    }

    getCurentProductRegExp = () => {
        let productValue = this.props.form.getFieldValue('products');
        let exp = "";
        if (Array.isArray(productValue))
            productValue = productValue[0];

        this.props.products.forEach((product) => {
            if (product.product === productValue) {
                exp = product.versionRegExp;
            }
        });
        return exp;
    }

    render = () => {
        let {status, message, serviceDepends, isAccountExpanded} = this.state;
        const {products, editMode, data, tenants, close, deleteFun, lockStatus, loading} = this.props;
        const {getFieldDecorator, getFieldValue, validateFields} = this.props.form;
        const transportType = getFieldValue('transports');
        const userNameValue = getFieldValue('credentials_username');

        return (
            <div className="page-tenant-detail">
                <div className="page-close" onClick={() => close()}>
                    <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                </div>
                <div className='page-detail-title'>
                    <i className={editMode ? 'page-detail-graphic graphic-policy' : 'page-detail-graphic graphic-policy-add'}></i>

                    <div className='page-detail-info'>
                        <b>Policy Configuration</b>
                    </div>
                </div>
                <div className="form-horizontal" style={{paddingLeft: "30px", paddingRight: "30px", maxWidth: "800px"}}>
                    { loading && (
                        <Alert bsStyle="info">
                            <Loading/>
                        </Alert>
                    )}

                    {   transportType === "container-registry" &&
                    <Alert bsStyle="info">
                        <CredentialNote/>
                    </Alert>
                    }
                    <Form onSubmit={(e) => this.save(e)} className="ant-form-horizontal">
                        {(status === Constants.STATUS.error || status === Constants.STATUS.done) &&
                        <div>
                            <div
                                className={status === Constants.STATUS.error ? "alert alert-dismissible alert-danger" : "alert alert-dismissible alert-info"}>
                                <strong>{message}</strong>
                            </div>
                        </div>
                        }


                        <div className="policy-config-title"><b>Basic Information</b></div>

                        <FormItem {...formItemLayout} label="Product">
                            {getFieldDecorator('products', {
                                initialValue: editMode ? data["products"] : undefined,
                                trigger: "onSelect",
                                rules: [{
                                    required: true, message: 'Please select a product!'
                                }],
                            })(
                                <Select placeholder="Select a product" onChange={() => {
                                    if (getFieldValue("version_value")) {
                                        validateFields(['version_value'], {force: true});
                                    }
                                }}>
                                    {products.map((product) => {
                                        return <Option key={product.product}
                                                       value={product.product}>{PRODUCT_SHOW_NAME[product.product] ? PRODUCT_SHOW_NAME[product.product] : product.product}</Option>
                                    })}
                                </Select>
                            )}
                        </FormItem>

                        <Row className="policy-input-group">
                            <Col span={12}>
                                <FormItem labelCol={{sm: {span: 12}}} wrapperCol={{sm: {span: 12}}} label="Version">
                                    {getFieldDecorator('version_operator', {
                                        initialValue: editMode ? data["version"]["operator"] : undefined,
                                        rules: [{
                                            required: true, message: 'Please select operator!'
                                        }],
                                    })(
                                        <Select placeholder="Operator">
                                            {
                                                Object.keys(OPERATOR_TYPES).map((value) => {
                                                    return <Option key={value} value={value}><label
                                                        dangerouslySetInnerHTML={{__html: OPERATOR_TYPES[value]}}/></Option>
                                                })
                                            }
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>

                            <Col span={12}>
                                <FormItem hasFeedback labelCol={{sm: {span: 0}}} wrapperCol={{sm: {span: 24}}}>
                                    {getFieldDecorator('version_value', {
                                        initialValue: data["version"]["value"],
                                        rules: [{
                                            required: true, message: 'Please input version number!'
                                        }, {validator: this.checkVersionFormat}]
                                    })(
                                        <Input/>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                        <FormItem {...formItemLayout} label="Tenant">
                            {getFieldDecorator('tid', {
                                initialValue: data["tid"]
                            })(
                                <Select showSearch
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    <Option value="">Global</Option>
                                    {
                                        tenants.sort((t1, t2) => {
                                            return t1.companyName.toLowerCase() === t2.companyName.toLowerCase() ? 0 : (t1.companyName.toLowerCase() > t2.companyName.toLowerCase() ? 1 : -1);
                                        }).map((value) => {
                                            return <Option key={value.tenantId}
                                                           value={value.tenantId}>{value.companyName + " (" + value.tenantDomain + ")"}</Option>
                                        })
                                    }
                                </Select>
                            )}
                        </FormItem>

                        <div className="policy-config-title"><b>Advanced</b></div>

                        <FormItem {...formItemLayout} label="Transport type">
                            {getFieldDecorator('transports', {
                                initialValue: Array.isArray(data["transports"]) ? data["transports"][0] : data["transports"],
                                rules: []
                            })(
                                <RadioGroup>
                                    {
                                        Object.keys(POLICY_TRANSPORTS).map(
                                            (key) => {
                                                return <RadioButton key={key}
                                                                    value={key}>{POLICY_TRANSPORTS[key]}</RadioButton>
                                            })
                                    }
                                </RadioGroup>
                            )}
                        </FormItem>

                        <URLItem transport={transportType} getFieldDecorator={getFieldDecorator} data={data}
                                 userNameValue={userNameValue} validateFields={validateFields}
                                 isAccountExpanded={isAccountExpanded} showAccountSettings={this.showAccountSettings}/>


                        <ContainerRegistry transport={transportType} addService={this.addService}
                                           deleteService={this.deleteService}
                                           serviceDepends={serviceDepends} getFieldDecorator={getFieldDecorator}
                                           data={data} getCurentProductRegExp={this.getCurentProductRegExp}/>

                        <br/>

                        <div className="ant-modal-footer" style={{padding: "10px 0"}}>
                            <Row>
                                <Col span="7" style={{"text-align": "left"}}>
                                    <PermissionCtrl permission={[Permissions.SoftwareUpgrade.EDIT]}>
                                        <Button type="primary" htmlType="submit" size="large"
                                                disabled={lockStatus === Lock_Status.lock_lock
                                                        || lockStatus === Lock_Status.lock_free}
                                                loading={status === Constants.STATUS.trying}>
                                            {status === Constants.STATUS.trying ? "Saving..." : "Save"}
                                        </Button>
                                    </PermissionCtrl>
                                    <Button htmlType="button" size="large" onClick={close}>
                                        Cancel
                                    </Button>
                                </Col>
                                <Col span="13"/>
                                {editMode &&
                                <PermissionCtrl permission={[Permissions.SoftwareUpgrade.DELETE]}>
                                    <Col span="4">
                                        <Button type="danger" size="large" htmlType="button"
                                                disabled={status === Constants.STATUS.trying
                                                        || lockStatus === Lock_Status.lock_lock
                                                        || lockStatus === Lock_Status.lock_free}
                                                onClick={() => {deleteFun([data["policyid"]], close);}}
                                                style={{float: "right"}}>
                                            Delete
                                        </Button>
                                    </Col>
                                </PermissionCtrl>
                                }
                            </Row>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }

}

class PolicyConfigViewAntd extends Component {
    constructor(props) {
        super(props);

        this.state = {
            editMode: false,
            data: this.getInitData(),
            status: Constants.STATUS.init,
            showModal: false,
            policyId: null
        };
    }

    componentDidMount() {
        const policyId = this.props.policyId;
        this.setState({ policyId });
        this._initData(policyId);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.policyId !== undefined
            && this.state.policyId !== nextProps.policyId) {
            this.setState({policyId: nextProps.policyId, data: this.getInitData()});
            this._initData(nextProps.policyId);
        }
    }

    _initData = (policyId) => {
        console.log("get policy:" + policyId);
        if (policyId) {
            this.setState({editMode: true, status: Constants.STATUS.trying});

            request.get('/api/pec1sumiddleware')
                .query({urlPath: '/policy/' + policyId})
                .end((err, res) => {
                    if (err) {
                        this.setState({status: Constants.STATUS.error, message: err.message});
                    } else {
                        var result = res.body;
                        if (!result.tid)
                            result.tid = "";
                        if (!result.meta)
                            result.meta = {};
                        this.setState({data: result, status: Constants.STATUS.done});
                    }
                })
        } else {
            this.setState({status: Constants.STATUS.done, data: this.getInitData()});
        }
    }

    getInitData = () => {
        return {
            products: "",
            transports: "https",
            tid: "",
            meta: {Format: "0.0.1", Version: "", ServiceDependencies: []},
            version: {operator: "", value: ""},
            credentials: {username: "", password: ""}
        };
    }

    close = () => {
        this.setState({data: this.getInitData(), showModal: false}, () => {
            if (this.props.onClose)
                this.props.onClose();
        });
    }

    render = () => {
        let {data, editMode, status} = this.state;
        const {products, tenants, deleteFun, lockStatus} = this.props;
        const ConfigFormWrap = Form.create()(PolicyConfigForm);

        return (
            <ConfigFormWrap data={data} products={products} tenants={tenants} close={this.close}
                            loading={status === Constants.STATUS.trying}
                            deleteFun={deleteFun} editMode={editMode} lockStatus={lockStatus}/>);
    }
}


export default PolicyConfigViewAntd;


// WEBPACK FOOTER //
// ./src/modules/policy/PolicyConfigRViewAntd.js